import I_globals from './interfaces/I_globals'

export const globals: I_globals = {
  externalInput: {
    wpAjaxURL: '',
    wpBaseURL: '',
    wpSpecalAjaxURL: ''
  }

}
